import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChatBubbleLeftRightIcon, EllipsisHorizontalIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router'

export default function RecentsMenu() {
  return (
    <Menu>
      <MenuButton
        aria-label="Recents options"
        data-tooltip="Recents options"
        className="absolute top-1/2 right-1 flex size-7 -translate-y-1/2 items-center justify-center rounded-md text-stone-500 opacity-0 transition hover:bg-black/5 hover:text-stone-900 group-hover:opacity-100 focus-visible:opacity-100 data-open:opacity-100 pointer-coarse:opacity-100"
      >
        <EllipsisHorizontalIcon className="size-4" />
      </MenuButton>

      <MenuItems
        anchor={{ to: 'bottom end', gap: 6 }}
        transition
        className="z-50 w-48 rounded-xl border border-stone-200/80 bg-white/85 p-1 shadow-[0_2px_4px_rgba(28,25,23,0.04),0_18px_44px_-16px_rgba(28,25,23,0.22)] backdrop-blur-md transition duration-100 ease-out data-closed:scale-95 data-closed:opacity-0"
      >
        <MenuItem>
          <Link
            to="/conversations"
            className="flex h-10 items-center gap-2.5 rounded-lg px-2.5 text-sm text-stone-700 transition-colors data-focus:bg-black/5 data-focus:text-stone-950 md:h-9"
          >
            <ChatBubbleLeftRightIcon className="size-4 text-stone-500" />
            Past conversations
          </Link>
        </MenuItem>
      </MenuItems>
    </Menu>
  )
}
